import { render, staticRenderFns } from "./Sale.vue?vue&type=template&id=0b7d0ccb&scoped=true"
import script from "./Sale.vue?vue&type=script&lang=js"
export * from "./Sale.vue?vue&type=script&lang=js"
import style0 from "./Sale.vue?vue&type=style&index=0&id=0b7d0ccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d0ccb",
  null
  
)

export default component.exports